/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";

export default function data(memberRoles = [], onDeleteClick = () => {}) {
  const MemberRole = ({ memberName, roleName }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="button" fontWeight="medium">
        {memberName}
      </MDTypography>
      <MDTypography variant="caption" color="text">
        {roleName}
      </MDTypography>
    </MDBox>
  );

  const StatusBadge = ({ isActive }) => (
    <MDBox
      display="inline-block"
      px={1.5}
      py={0.5}
      borderRadius="lg"
      bgColor={isActive ? "success" : "error"}
    >
      <MDTypography variant="caption" color="white" fontWeight="bold">
        {isActive ? "Active" : "Inactive"}
      </MDTypography>
    </MDBox>
  );

  const getMemberName = (item) =>
    item.memberName || item.MemberName || item.member?.name || item.Member?.Name || "";

  const getRoleName = (item) =>
    item.roleName || item.RoleName || item.role?.name || item.Role?.Name || "";

  const getIsActive = (item) => {
    const value = item?.isActive ?? item?.IsActive;

    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      return normalized === "true" || normalized === "1" || normalized === "active";
    }

    return false;
  };

  const getMemberRoleId = (item) =>
    item.memberRoleId ?? item.MemberRoleId ?? item.id ?? item.Id ?? null;

  return {
    columns: [
      {
        Header: "member role",
        accessor: "memberRoleSearch",
        width: "60%",
        align: "left",
        Cell: ({ row }) => (
          <MemberRole memberName={row.original.memberName} roleName={row.original.roleName} />
        ),
      },
      {
        Header: "role",
        accessor: "roleName",
        align: "center",
        Cell: ({ value }) => (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {value}
          </MDTypography>
        ),
      },
      {
        Header: "status",
        accessor: "statusText",
        align: "center",
        Cell: ({ row }) => <StatusBadge isActive={row.original.isActive} />,
      },
      {
        Header: "action",
        accessor: "actionText",
        align: "center",
        Cell: ({ row }) => (
          <IconButton
            aria-label={`delete-member-role-${row.original.memberRoleId ?? "row"}`}
            color="error"
            onClick={() => onDeleteClick(row.original)}
            size="small"
          >
            <Icon fontSize="small">delete</Icon>
          </IconButton>
        ),
      },
    ],

    rows: memberRoles.map((item) => ({
      memberRoleId: getMemberRoleId(item),
      memberName: getMemberName(item),
      roleName: getRoleName(item),
      isActive: getIsActive(item),
      memberRoleSearch: `${getMemberName(item)} ${getRoleName(item)}`.trim(),
      statusText: getIsActive(item) ? "Active" : "Inactive",
      actionText: "Delete",
    })),
  };
}
